// extracted by mini-css-extract-plugin
export default {"main":"MainGrid_main__4PmRi"};